import http from './api'

const route = 'listapedido'

export default {
    usuario: (username, contratoId) => {
        return http.post(route + '/usuario', {
            username: username,
            contratoId: contratoId,
        })
    },

    showPedido: (usuarioId, contratoId, pagina) => {
        return http.post(route + '/showPedido', {
            usuarioId: usuarioId,
            contratoId: contratoId,
            pagina: pagina,
        })
    },
}
